<template>
    <v-container fluid>
        <v-row>
            <v-col class="text-right">
                <v-btn icon large :loading="downloading" @click="download">
                    <v-icon>
                        mdi-download
                    </v-icon>
                </v-btn>
                <ToggleFilterBtn />
            </v-col>
        </v-row>
        <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading"
            :single-expand="true"
            :expanded.sync="expanded"
            item-key="items[0].reseller_name"
            show-expand
            class="elevation-3"
            hide-default-footer
            :items-per-page="-1"
        >
            <template v-slot:[`item.totals.value`]="{ item }">
                {{ $n(item.totals.value, 'currency') }}
            </template>

            <template v-slot:[`item.totals.over_value`]="{ item }">
                {{ $n(item.totals.over_value, 'currency') }}
            </template>

            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" class="pt-3 pa-2">
                    <v-data-table
                        :headers="detailHeaders"
                        :items="item.items"
                        :items-per-page="-1"
                        hide-default-footer
                        class="grey lighten-4"
                    >
                        <template v-slot:[`item.start_at`]="{ item }">
                            {{ $d(Date.parse(item.start_at), 'short') }}
                        </template>

                        <template v-slot:[`item.end_at`]="{ item }">
                            {{ $d(Date.parse(item.end_at), 'short') }}
                        </template>

                        <template v-slot:[`item.value`]="{ item }">
                            {{ $n(item.value, 'currency') }}
                        </template>

                        <template v-slot:[`item.over_value`]="{ item }">
                            {{ $n(item.over_value, 'currency') }}
                        </template>
                    </v-data-table>
                </td>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import axios from '@/plugins/axios'
import i18n from '@/plugins/i18n'
import ToggleFilterBtn from '@/shared/components/filters/ToggleFilterBtn'

export default {
    components: {
        ToggleFilterBtn,
    },

    data() {
        return {
            loading: true,
            downloading: false,
            items: [],
            expanded: [],
            headers: [
                {
                    text: i18n.t('reports.bills.table.reseller-name'),
                    sortable: true,
                    value: 'items[0].reseller_name',
                },
                {
                    text: i18n.t('reports.bills.table.customers'),
                    value: 'totals.customers',
                },
                {
                    text: i18n.t('reports.bills.table.value'),
                    value: 'totals.value',
                },
                {
                    text: i18n.t('reports.bills.table.over-value'),
                    value: 'totals.over_value',
                },
                {
                    text: i18n.t('reports.bills.table.expand'),
                    value: 'data-table-expand',
                },
            ],
            detailHeaders: [
                {
                    text: i18n.t('reports.bills.table.customer'),
                    value: 'customer_name',
                },
                {
                    text: i18n.t('reports.bills.table.start-at'),
                    value: 'start_at',
                },
                {
                    text: i18n.t('reports.bills.table.end-at'),
                    value: 'end_at',
                },
                {
                    text: i18n.t('reports.bills.table.value'),
                    value: 'value',
                },
                {
                    text: i18n.t('reports.bills.table.over-value'),
                    value: 'over_value',
                },
            ],
        }
    },

    watch: {
        filters() {
            this.fetchData()
        },
    },

    computed: {
        filterKey() {
            return 'billsReport'
        },

        filters() {
            return this.$store.getters['filters/current'][this.filterKey]
        },

        filtersQuery() {
            return this.$store.getters['filters/queryString'](this.filterKey)
        },
    },

    methods: {
        fetchData() {
            this.loading = true
            let url = '/reports/billable?' + this.filtersQuery

            axios
                .get(url)
                .then(response => {
                    this.items = Object.values(response.data.data.resellers)
                    this.setFilters(response.data.meta.filters)
                    this.loading = false
                })
                .catch(error => {
                    this.$bus.$emit('notify', 'error', 'Ocorreu um erro.')
                    this.loading = false
                    return error
                })
        },

        async setFilters(filters) {
            this.$bus.$emit('filters', {
                resource: this.filterKey,
                allowed: filters.allowed,
            })
            this.hasFilters = true
        },

        async download() {
            this.downloading = true
            const endpoint = '/reports/billable/download?' + this.filtersQuery

            let res = await this.$http.get(endpoint, {
                responseType: 'blob',
            })
            if (!res) return
            const url = window.URL.createObjectURL(new Blob([res.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'reseller-report.csv')
            document.body.appendChild(link)
            link.click()
            this.downloading = false
        },
    },

    mounted() {
        this.fetchData()
    },
}
</script>

<style></style>
